import clone from "ramda/src/clone"

export const cloneDeep = (obj) => {
    return clone(obj);
}
